export enum UserRole {
  CLIENT = 'CLIENT',
  ADMIN = 'ADMIN',
}
